import React, { useContext, useEffect } from 'react';
import Loader from 'features/Loader/Loader';
import { AuthContext } from 'features/auth/context/Auth';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import ClientHead from './ClientHead';
import ClientSide from './ClientSide';
import ClientTabs from './ClientTabs';
import './ClientProfile.scss';
import { getClient } from '../ducks/clientProfileActions';
import { getNotes } from './notesTab/ducks/noteActions';
import ProgressPhotosHistory from './progressTab/progress-photos/ProgressPhotosHistory';

const ClientProfile = props => {
  const { currentUser } = useContext(AuthContext) || {};
  const clientId = props.match.params.client_id;

  useEffect(() => {
    props.getClient(clientId, props.history);
    props.getNotes(currentUser.uid, clientId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);

  let { client, notes, loading } = props;
  return !loading && client ? (
    <div className="client-profile">
      <ClientHead
        userName={`${client.first_name} ${client.last_name}`}
        clientId={clientId}
        history={props.history}
        isActive={client.is_active}
      />
      <div className="container">
        <div className="client-profile-content">
          <ClientSide client={client} />
          <Switch>
            <Route
              path="/clients/:id/progress-photos"
              component={() => (
                <div className="client-profile-tabs">
                  <ProgressPhotosHistory clientId={clientId} />
                </div>
              )}
            />
            <Route
              path="/clients/:id"
              component={() => (
                <ClientTabs clientId={clientId} client={client} notes={notes} />
              )}
            />
          </Switch>
        </div>
      </div>
    </div>
  ) : (
    <Loader />
  );
};

function mapStateToProps(state) {
  return {
    client: state.clientProfileReducer.client,
    loading: state.clientProfileReducer.loading,
    notes: state.notesReducer.notes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getClient: (clientId, history) => dispatch(getClient(clientId, history)),
    getNotes: (trainerId, clientId) => dispatch(getNotes(trainerId, clientId))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientProfile);
